import {
  COP_API_BASE_URL,
  getCustomerBusinessUnitsUrl,
  getProductCategoriesUrl,
} from '../../../constants/service-endpoints'
import { get } from '../../../services/http.service'

export interface BusinessUnit {
  id: number
  name: string
  shortName: string
}

export interface ProductCategory {
  id: number
  name: string
  className: string
  businessUnitId: number
  businessUnitName: string
  businessUnitShortName: string
}

interface BusinessUnitsResponse {
  value: BusinessUnit[]
}

interface ProductCategoriesResponse {
  value: ProductCategory[]
}

export async function fetchBusinessUnits(): Promise<BusinessUnit[]> {
  const url = `${COP_API_BASE_URL}${getCustomerBusinessUnitsUrl()}?$orderby=name`
  const raw = await get<BusinessUnitsResponse>(url)
  return raw?.value ?? []
}

export async function fetchProductCategories(businessUnitId: number): Promise<ProductCategory[]> {
  const url = `${COP_API_BASE_URL}${getProductCategoriesUrl(businessUnitId)}`
  const raw = await get<ProductCategoriesResponse>(url)
  return raw?.value ?? []
}
